import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import AccountIntePage from './AccountIntePage'
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchDealDetails } from "../../../../Api/Services/DealApiService"
import { fetchDomainAvaliability, extractDomain } from "../../../../Api/Services/CompanyApiService"
import { ExchangeCurrency } from '../../Filters/FilterConditions';
import { ReportsIcon, ScoreIcon } from '../../../../components/Icons/Icons';
import Meeting from '../../TablesAndTimelines/MeetingTable'
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload'
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import { dealInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, currencySettings, trigger }) => {  // contactListData
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const companyProfile = localData.company
    const [userData, setUserData] = useState()
    const [accountData, setAccountData] = useState()
    const [dealData, setDealData] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen3, setIsOpen3] = useState(true);
    const [isOpen7, setIsOpen7] = useState(false);
    const [isOpen5, setIsOpen5] = useState(true);
    const [isOpen6, setIsOpen6] = useState(false);
    const [report, setReport] = useState()
    const [openIntelligence, setOpenIntelligence] = useState(false);
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    const handleExpand5 = (key) => {
        setIsOpen5(key.length > 0);
    };
    const handleExpand6 = (key) => {
        setIsOpen6(key.length > 0);
    };
    const handleExpand7 = (key) => {
        setIsOpen7(key.length > 0);
    };
    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
            if (merged?.website) {
                getAccountReports(merged?.website)
            } else {
                setReport({ allow: false, data: null })
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function getDealData(params) {
        try {
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const ConvertRate = currencySettings?.exchangeRate;
            const dealresponse = await FetchDealDetails(params)
            const Response = dealresponse.data
            const CurrecnyDealValue = await ExchangeCurrency(Number(Response.dealValue), ConvertRate)
            const merged = { ...Response, dealValue: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)), DataPermission: { isPresent: dealresponse.allow } };
            setDealData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (isOpen6) {
            if (displayData?.dealOwner) {
                getUsersData(displayData?.dealOwner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.dealOwner, isOpen6])
    useEffect(() => {
        if (isOpen5) {
            if (displayData?.account_id) {
                getAccountData(displayData?.account_id)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.account_id, isOpen5])
    useEffect(() => {
        if (isOpen7) {
            if (displayData?.parentDealId) {
                getDealData(displayData?.parentDealId)
            } else {
                setDealData()
            }
        }
    }, [displayData?.parentDealId, isOpen7])
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await dealInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200 && response.statusText === "OK") {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            minWidth: 0,
                        }}
                    >
                        <Text
                            strong
                            style={{
                                fontSize: 14,
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                            }}
                        >
                            Deal Score
                        </Text>
                        <div className='Hover-Refresh3 back-hover2 able-style'
                            role="button"
                            tabIndex={0} title='View Score Insights'
                            onClick={(e) => {
                                e.stopPropagation();   // ✅ IMPORTANT
                                openScoreGeniee();
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.stopPropagation();
                                    openScoreGeniee()
                                }
                            }}
                            aria-label='insights'
                        ><ScoreIcon height={20} width={20} /></div>
                    </div>
                    <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}>
                        <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                    </div>
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
            {(displayData?.account_id) && <>
                <Divider style={{ margin: "10px 0" }} />
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand5} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                minWidth: 0,
                            }}
                        >
                            <Text
                                strong
                                style={{
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                }}
                            >
                                Account
                            </Text>
                            {isOpen5 ? <div className={!report?.allow ? "disabled-style" : 'Hover-Refresh3 back-hover2 able-style'}
                                role="button"
                                tabIndex={0} title='View Account Intelligence Report'
                                onClick={!report?.allow ? undefined : () => openTacking()}
                                onKeyDown={(event) => {
                                    if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                                        openTacking()
                                    }
                                }}
                                aria-label='report'
                            ><ReportsIcon height={20} width={20} /></div> : <></>}
                        </div>

                        <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen5 ? "Close" : "View"}</Text></div>} key="1">
                        {accountData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={accountData?.DataPermission?.isPresent ? () => accountData?.account_id && ViewDetailPage(accountData?.account_id, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(accountData?.account_id, "ACCOUNT")
                                    }
                                }}
                            >
                                {accountData?.accountProfile !== null && accountData?.accountProfile
                                    !== undefined && accountData?.accountProfile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.accountProfile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                        {accountData?.accountName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.accountName}>{accountData?.accountName}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.accountNumber}>{accountData?.accountNumber}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.industry && accountData?.industry !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                            <br />
                                            <Text >{accountData?.industryName}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.nomOfEmployees && accountData?.nomOfEmployees !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                            <br />
                                            <Text >{accountData?.nomOfEmployeesName}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.annualRevenue && accountData?.annualRevenue !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                            <Text >{accountData?.annualRevenueName}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.rating && accountData?.rating !== "") ?
                                        <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                            <Text >{accountData?.rating}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            {accountData?.accountOwner &&
                                <div><Text type="secondary" className='RightSide-Lable'>Account Owner</Text> <br />
                                    <Text >
                                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === accountData?.accountOwner) && "ListNavigate"}`}
                                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === accountData?.accountOwner) ? () => accountData?.accountOwner && ViewDetailPage(accountData?.accountOwner, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(accountData?.accountOwner, "USER");
                                                }
                                            }}> {accountData?.userProfilePic !== null && accountData?.userProfilePic
                                                !== undefined && accountData?.userProfilePic !== "" ?
                                                <figure>
                                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.userProfilePic} alt="" />
                                                </figure>
                                                :
                                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                    {accountData?.userFirstName?.slice(0, 1).toUpperCase()}
                                                </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={`${accountData?.userFirstName} ${accountData?.userLastName}`}> {`${accountData?.userFirstName} ${accountData?.userLastName}`}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={accountData?.accountOwnerEmail}>{accountData?.accountOwnerEmail}</div>
                                            </figcaption>
                                        </div>
                                    </Text>
                                </div>
                            }
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse></>}
            <Divider style={{ margin: "10px 0" }} />
            {(displayData?.parentDealId) && <>
                <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand7} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Parent Deal</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen7 ? "Close" : "View"}</Text></div>} key="1">
                        {dealData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${dealData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={dealData?.DataPermission?.isPresent ? () => dealData?.deals_id && ViewDetailPage(dealData?.deals_id, "DEAL") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(dealData?.deals_id, "DEAL")
                                    }
                                }}
                            >
                                {dealData?.dealProfile !== null && dealData?.dealProfile
                                    !== undefined && dealData?.dealProfile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={dealData?.dealProfile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag DealIcon' style={{ flexShrink: 0, }}>
                                        {dealData?.dealName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={dealData?.dealName}>{dealData?.dealName}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={dealData?.dealTypeName}>{dealData?.dealTypeName}</div>
                                </figcaption>
                            </div>
                            {(dealData?.pipelineStage && dealData?.pipelineStage !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Pipeline Stage</Text>
                                    <br />
                                    <Text ><div className={`table_list_clicks status-text PipeLine${dealData.pipelineStage}`}>{dealData.pipelineStageName}</div>
                                    </Text>
                                </div> : <></>}
                            {(dealData?.dealValue !== undefined && dealData?.dealValue !== null && dealData?.dealValue !== "") ?
                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Deal Value ({currencySettings?.currency})</Text>
                                    <br />
                                    <Text>{`${currencySettings?.symbol} ${dealData.dealValue.toLocaleString()}`}</Text>
                                </div> : <></>}
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse> <Divider style={{ margin: "10px 0" }} /> </>}
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand6} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Deal Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen6 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel>
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end" >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.dealFiles?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.dealFiles?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    // Role: PropTypes.string.isRequired
    // contactListData: PropTypes.array.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    currencySettings: PropTypes.object.isRequired,
};
export default NoteDetails;
